<template>
  <div class="input-form-text-box">
    <div v-show="showableLabel" class="input-form-text-box__label">
      <label class="module-text" :for="inputId">
        {{ label }}
      </label>
    </div>
    <input
      :id="inputId"
      type="text"
      class="input-form"
      :class="{
        'input-form--inputting': isTextFocused,
        'input-form--inputted': isTextActive,
        'input-form--error': showableError
      }"
      :autocomplete="autocomplete"
      :name="inputId"
      :value="value"
      :placeholder="placeholder"
      @input="$emit('input', $event.target.value)"
      @focus="onTextFocus"
      @blur="onTextBlur"
    />
    <p
      v-for="(errorMessage, index) in errorMessages"
      :key="index"
      class="error-message"
    >
      {{ errorMessage }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    inputId: {
      type: String,
      required: true
    },
    autocomplete: {
      type: String,
      required: false,
      default: 'off'
    },
    label: {
      type: String,
      required: true
    },
    showableLabel: {
      type: Boolean,
      default: true
    },
    value: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      required: false,
      default: ''
    },
    errorMessages: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data() {
    return {
      isTextFocused: false
    }
  },
  computed: {
    isTextInputted() {
      return this.value.length !== 0
    },
    isTextActive() {
      return !this.isTextFocused && this.isTextInputted
    },
    showableError() {
      return this.errorMessages.length !== 0
    }
  },
  methods: {
    onTextFocus() {
      this.isTextFocused = true
    },
    onTextBlur() {
      this.isTextFocused = false
    }
  }
}
</script>

<style lang="scss" scoped>
.input-form-text-box {
  text-align: left;

  &__label {
    margin-bottom: 8px;
  }
}
</style>
